import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const UpperCase = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.144 5.132a.5.5 0 0 0 .707-.707L4.173 2.747a.5.5 0 0 0-.707 0L1.787 4.425a.5.5 0 1 0 .708.707l.824-.824v2.715a.5.5 0 1 0 1 0V4.308l.825.824Zm6.367 8.236c-2.08 0-3.315-1.313-3.315-3.614v-7.07h1.26V9.65c0 1.664.729 2.522 2.055 2.522 1.339 0 2.067-.858 2.067-2.522V2.683h1.26v7.071c0 2.301-1.234 3.614-3.327 3.614Zm-6.526-2.434V7.752h1.14v5.454H5.012v-.955h-.057a1.69 1.69 0 0 1-.604.735c-.277.194-.621.291-1.033.291-.35 0-.662-.078-.934-.234a1.643 1.643 0 0 1-.636-.692c-.151-.306-.227-.682-.227-1.13v-3.47H2.66v3.317c.002.365.103.655.301.87.202.214.462.32.782.32a1.257 1.257 0 0 0 1.054-.582c.126-.197.189-.444.189-.742Z"
        clipRule="evenodd"
      />
    </svg>
  )
})

export default UpperCase
